// src/components/AvatarCropModal.jsx
import React, { useRef, useState } from "react";
import AvatarEditor from "react-avatar-editor";

const AvatarCropModal = ({ imageFile, onCancel, onSave }) => {
  const editorRef = useRef(null);
  const [scale, setScale] = useState(1.2);

  const handleSave = async () => {
    if (editorRef.current) {
      const canvas = editorRef.current.getImageScaledToCanvas();
      canvas.toBlob((blob) => {
        if (blob) onSave(blob);
      }, "image/jpeg");
    }
  };

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h2 style={styles.title}>Adjust Your Profile Picture</h2>

        <AvatarEditor
          ref={editorRef}
          image={imageFile}
          width={250}
          height={250}
          border={50}
          borderRadius={125}
          color={[0, 0, 0, 0.5]}  // ✅ Updated for darker outer shading
          scale={scale}
          rotate={0}
        />


        <input
          type="range"
          min="1"
          max="3"
          step="0.01"
          value={scale}
          onChange={(e) => setScale(parseFloat(e.target.value))}
          style={{ width: "100%", marginTop: "16px" }}
        />

        <div style={styles.buttonRow}>
          <button onClick={onCancel} style={styles.cancel}>Cancel</button>
          <button onClick={handleSave} style={styles.save}>Save</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  backdrop: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 1000
  },
  modal: {
    background: "white",
    padding: "24px",
    borderRadius: "12px",
    width: "400px",
    boxShadow: "0 0 20px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  title: {
    marginBottom: "16px",
    fontSize: "18px",
    fontWeight: "bold"
  },
  buttonRow: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "space-between",
    width: "100%"
  },
  cancel: {
    backgroundColor: "#e5e7eb",
    color: "#111827",
    padding: "8px 16px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer"
  },
  save: {
    backgroundColor: "#2563eb",
    color: "white",
    padding: "8px 16px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer"
  }
};

export default AvatarCropModal;
